import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (params) {
  const { data, exec, isLoading, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_MOULDS',
  });

  const fetchData = function () {
    if (params && JSON.stringify(params) !== '{}') {
      let url = `/api/moulds`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [data || {}, fetchData, isLoading, isRequestSuccessed];
}
